import SampleReportView from "@/components/samples/SampleReportView";
import { CITADEL_REPORT } from "@/data/sample-reports";

const CitadelSample = () => <SampleReportView report={CITADEL_REPORT} />;

export default CitadelSample;
